import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import FullHeightConnector from '../../atoms/FullHeightConnector'
import { Step, StepLabel, Stepper } from '@material-ui/core'
import { useIconStyles, trackingStepColors } from '../../../utils/customStyles'

const TrackingGeneralSteps = ({ stepValues = [], isEnded, stepWithColor = false }) => {
  const classes = useIconStyles()
  const colors = trackingStepColors()
  const activeStep = stepValues.length - 1
  const isLastState = index => activeStep === index

  return (
    <div className="p-6 bg-blue-350 md:rounded-b-xl">
      <div className="text-lg font-bold mb-3">Avance</div>
      <Stepper
        className={'bg-blue-350 p-0'}
        activeStep={activeStep}
        orientation="vertical"
        connector={<FullHeightConnector />}
      >
        {stepValues.map((step, index) => (
          <Step key={index}>
            <StepLabel
              classes={{ root: 'items-start' }}
              StepIconComponent={() => (
                <div
                  className={clsx(
                    isLastState(index) && !isEnded && stepWithColor ? colors[step.color] : colors.success,
                    classes.root
                  )}
                />
              )}
            >
              <span className="text-base leading-tight mb-2 block">{step.name}</span>
              <span className={clsx('text-sm text-gray-500 font-normal', isLastState(index) && isEnded && 'mb-4')}>
                {step.date}
              </span>
            </StepLabel>
          </Step>
        ))}
        {!isEnded && (
          <Step>
            <StepLabel StepIconComponent={() => <div className={clsx(colors.gray, classes.root)} />}></StepLabel>
          </Step>
        )}
      </Stepper>
    </div>
  )
}
export default TrackingGeneralSteps

TrackingGeneralSteps.propTypes = {
  stepValues: PropTypes.array,
  isEnded: PropTypes.bool,
  stepWithColor: PropTypes.bool
}
